import produce from 'immer';
import { getPromoCodeTerms } from '../../services';
import { changed } from '../../utils/';
import { BookingState } from '../state';
import { SideEffect, SideEffectGenerator, Store } from '../types';
import { bindActions } from 'redux-zero/utils';

export const getPromoCodeTermsEffect = (store: Store<BookingState>): SideEffect<BookingState> => {
  const effectActions = bindActions(
    {
      _getPromoCodeTermsStart: (state) =>
        produce(state, ({ ux }: BookingState) => {
          ux.loading.getPromoCodeTerms = true;
        }),
      _getPromoCodeTermsFinish: (state, terms: string, title: string) =>
        produce(state, ({ ux, selection }: BookingState) => {
          ux.loading.getPromoCodeTerms = false;
          selection.promoCodeTerms = terms;
          selection.promoCodeTermsTitle = title;
          selection.promoCodeNotFoundError = !terms;
          if (!terms) {
            selection.promoCode = null;
          }
        }),
    },
    store
  );

  return {
    runSideEffects: (readOnlyState) => {
      const {
        envConfig,
        selection: { promoCode, locale },
      } = readOnlyState;

      effectActions._getPromoCodeTermsStart();
      getPromoCodeTerms(envConfig, locale, promoCode).then((response) => {
        effectActions._getPromoCodeTermsFinish(response?.terms, response?.title);
      });
    },
    when: (prev, next) => {
      return (
        (changed(prev, next, 'selection', 'promoCode') ||
          (!prev.selection.promoCodeTerms && !prev.ux.loading.getPromoCodeTerms)) &&
        !!next.selection.promoCode
      );
    },
    name: getPromoCodeTermsEffect.name,
  };
};

export const promoCodeEffects: SideEffectGenerator<BookingState>[] = [getPromoCodeTermsEffect];
